import LeadEndScreenSettings from './LeadEndScreenSettings';

export default LeadEndScreenSettings;
